import { StavVolani } from '@mc/poh';

const captions = {
    [StavVolani.OK]: 'OK',
    [StavVolani.ERR]: 'Chyba',
};

const icons = {
    [StavVolani.ERR]: 'ban',
    [StavVolani.OK]: 'check-square-o',
};

export function getIcon(value) {
    return icons[value];
}

export function getCaption(value) {
    return captions[value];
}

